import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const PhoneIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 24 24", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <rect fill="none" y="0.01" width="24" height="24" />
            <path
                fill="currentColor"
                d="M19.36,21.54h-.12c-6.41-.67-11.12-3.32-14-7.88a19.08,19.08,0,0,1-2.81-9,1.23,1.23,0,0,1,.33-.91,1.26,1.26,0,0,1,.9-.38H7.27A1.34,1.34,0,0,1,8.6,4.73V7.41A1.86,1.86,0,0,1,8,8.78L6.91,9.83c.78,1.38,3.59,6,7.28,7.13l1-1a1.83,1.83,0,0,1,1.31-.54l2.73,0a1.42,1.42,0,0,1,.94.39,1.32,1.32,0,0,1,.4,1V20.3a1.25,1.25,0,0,1-.41.92A1.22,1.22,0,0,1,19.36,21.54ZM3.65,4.6C3.79,8,5.43,18.89,19.36,20.34l0-3.61a.15.15,0,0,0,0-.1.19.19,0,0,0-.1,0h0l-2.73,0a.7.7,0,0,0-.47.19l-1.51,1.5-.33-.08c-5-1.29-8.44-8-8.58-8.24l-.2-.4L7.2,7.91a.67.67,0,0,0,.21-.49V4.74a.13.13,0,0,0-.13-.14Z"
            />
        </SvgIcon>
    );
};
